import React from 'react';
import { gql } from '@apollo/client';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSHeading, EGDSHeadingSize } from '@egds/react-core/text';
import { BannerFieldsFragment } from 'common/__generated__/api/types';
import { FragmentComponent } from 'components/component-types';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ViewSizes, useViewportMap } from '@shared-ui/viewport-context';
const fragment = gql`
  fragment BannerFields on HelpCenterWelcomeBanner {
    heading
    heroImage {
      url
      description
    }
    subHeading
  }
`;

interface BannerProps {
  data: BannerFieldsFragment;
}

export const WelcomeBanner: FragmentComponent<BannerProps, BannerFieldsFragment> = (props: BannerProps) => {
  const data = props.data;
  const sizeForSubHeading = useViewportMap<EGDSHeadingSize>({
    [ViewSizes.SMALL]: 5,
    [ViewSizes.MEDIUM]: 4,
  });

  return (
    <Experiment name="Help_Center_Web_Landing_Page_UX_M2">
      <ExperimentControl>
        <div className={'welcome-div'}>
          <EGDSLayoutFlex
            justifyContent="center"
            wrap="nowrap"
            className={'welcome-banner no-border'}
            data-stid="banner"
          >
            <EGDSLayoutFlexItem>
              <EGDSLayoutFlex justifyContent="center" alignItems="start" direction={'column'}>
                <EGDSHeading tag="h1" align="center" className={'welcome-heading'} data-stid="bannerHeading">
                  {data.heading}
                </EGDSHeading>
                <EGDSHeading tag="h2" align="left" className={'welcome-subheading'} data-stid="bannerSubHeading">
                  {data.subHeading}
                </EGDSHeading>
              </EGDSLayoutFlex>
            </EGDSLayoutFlexItem>
          </EGDSLayoutFlex>
        </div>
      </ExperimentControl>
      <ExperimentVariant bucket={1}>
        <div>
          <EGDSLayoutFlex wrap="nowrap" style={{ marginTop: '56px' }} data-stid="banner">
            <EGDSLayoutFlexItem>
              <EGDSLayoutFlex justifyContent="center" alignItems="start" direction={'column'}>
                <EGDSHeading tag="h1" align="center" size={3} data-stid="bannerHeading">
                  {data.heading}
                </EGDSHeading>
                <EGDSHeading
                  tag="h2"
                  align="center"
                  size={sizeForSubHeading}
                  data-stid="bannerSubHeading"
                  style={{ marginTop: '32px', marginBottom: '32px' }}
                >
                  {data.subHeading}
                </EGDSHeading>
              </EGDSLayoutFlex>
            </EGDSLayoutFlexItem>
          </EGDSLayoutFlex>
        </div>
      </ExperimentVariant>
    </Experiment>
  );
};
WelcomeBanner.fragment = fragment;
WelcomeBanner.displayName = 'Banner';
